import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconHire(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="m10.793 9.8 3.333-3.496c.446-.468.446-1.247 0-1.724L12.65 3.032 13.634 2l1.476 1.548c.994 1.042.994 2.746 0 3.788l-3.333 3.495-.984-1.032ZM8.936 7.851l.547-.574a1.265 1.265 0 0 0 0-1.714l-.547-.575.984-1.042.548.575c.993 1.042.993 2.746 0 3.788l-.548.574-.984-1.032Zm4.699 4.927 5.19-5.443a1.122 1.122 0 0 1 1.643 0l.548.574.985-1.032-.548-.574a2.478 2.478 0 0 0-3.612 0l-5.19 5.443.984 1.032ZM2 22l13-4.869-8.357-8.763L2 22Zm9.61-5.667-6.546 2.454 2.34-6.865 4.206 4.411Zm4.373-4.187-1.476 1.548.984 1.032 1.476-1.548a1.122 1.122 0 0 1 1.644 0l1.495 1.568.984-1.032-1.495-1.568a2.478 2.478 0 0 0-3.612 0Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
